<template>
  <div class="contents-block dx-card responsive-paddings">
    <DxForm
      :ref="searchFormRefName"
      label-location="left"
      :form-data="formData"
    >
      <DxColCountByScreen :xs="1" :sm="2" :md="4" :lg="5" />

      <DxSimpleItem
        data-field="spaceId"
        editor-type="dxSelectBox"
        :editor-options="{
          dataSource: spaceList,
          valueExpr: 'spaceId',
          displayExpr: 'spaceNameId',
        }"
      >
        <DxLabel text="스페이스" />
        <DxRequiredRule />
      </DxSimpleItem>

      <DxSimpleItem
        data-field="type"
        editor-type="dxSelectBox"
        :editor-options="{ dataSource: ['시간', '일', '주', '월'] }"
      >
        <DxLabel text="구분" />
        <DxRequiredRule />
      </DxSimpleItem>

      <DxSimpleItem
        data-field="startDate"
        editor-type="dxDateBox"
        :editor-options="{
          displayFormat: 'yyyy/MM/dd',
          value: defaultStartDate,
        }"
      >
        <DxLabel text="시작 날짜" />
        <DxRequiredRule />
      </DxSimpleItem>

      <DxSimpleItem
        data-field="endDate"
        editor-type="dxDateBox"
        :editor-options="{ displayFormat: 'yyyy/MM/dd', value: defaultEndDate }"
      >
        <DxLabel text="끝 날짜" />
        <DxRequiredRule />
      </DxSimpleItem>

      <DxButtonItem
        horizontal-alignment="center"
        vertical-alignment="center"
        :buttonOptions="{
          text: '조회',
          icon: 'search',
          onClick: searchData,
        }"
      />
    </DxForm>
  </div>
  <div class="contents-block dx-card responsive-paddings">
    <DxChart :data-source="dataSourceGraph" palette="Harmony Light">
      <DxTitle
        v-if="typeName"
        :text="typeName + ' 별 접속자 통계'"
        horizontalAlignment="center"
      />
      <DxCommonSeriesSettings type="line" argument-field="type" />
      <DxCommonAxisSettings>
        <DxGrid :visible="true" />
      </DxCommonAxisSettings>
      <DxTooltip :enabled="true" />
      <DxSeries value-field="totalCnt" name="총 접속 수" />
      <DxSeries value-field="pcCnt" name="PC 접속 수" />
      <DxSeries value-field="mobileCnt" name="모바일 접속 수" />
      <DxLegend vertical-alignment="bottom" horizontal-alignment="center" />
      <DxExport :enabled="true" />
    </DxChart>
  </div>
  <div class="contents-block dx-card responsive-paddings">
    <DxDataGrid
      id="grid"
      :ref="gridRefName"
      :dataSource="dataSource"
      :show-borders="true"
      :show-column-lines="true"
      :columnAutoWidth="true"
      @exporting="onExporting"
      @cell-prepared="onCellPrepared"
    >
      <DxSearchPanel :visible="true" />
      <DxHeaderFilter :visible="true" />
      <DxScrolling mode="infinite" />
      <DxSorting mode="none" />
      <DxExport :enabled="true" />
      <DxColumn
        data-field="type"
        :caption="typeName"
        :header-filter="{ allowSearch: true }"
      />
      <DxColumn
        data-field="totalCnt"
        caption="총 접속 수"
        data-type="number"
        :minWidth="150"
        :header-filter="{ allowSearch: true }"
      >
      </DxColumn>
      <DxColumn
        data-field="pcCnt"
        caption="PC 접속 수"
        data-type="number"
        :minWidth="150"
        :header-filter="{ allowSearch: true }"
      >
      </DxColumn>
      <DxColumn
        data-field="mobileCnt"
        caption="모바일 접속 수"
        data-type="number"
        :minWidth="150"
        :header-filter="{ allowSearch: true }"
      >
      </DxColumn>
    </DxDataGrid>
  </div>
</template>

<script>
var endDate = new Date();
var startDate = new Date();
startDate.setDate(endDate.getDate() - 7);
var defaultStartDate = startDate;
var defaultEndDate = endDate;

import {
  DxForm,
  DxColCountByScreen,
  DxSimpleItem,
  DxButtonItem,
  DxLabel,
  DxRequiredRule,
} from "devextreme-vue/form";
import {
  DxDataGrid,
  DxScrolling,
  DxColumn,
  DxSorting,
  DxSearchPanel,
  DxHeaderFilter,
  DxExport,
} from "devextreme-vue/data-grid";
import {
  DxChart,
  DxTitle,
  DxCommonSeriesSettings,
  DxSeries,
  DxLegend,
  DxCommonAxisSettings,
  DxGrid,
  DxTooltip,
} from "devextreme-vue/chart";
import dsu from "../../utils/dataSourceUtils";
import fn from "../../utils/function";

export default {
  components: {
    DxForm,
    DxColCountByScreen,
    DxSimpleItem,
    DxButtonItem,
    DxLabel,
    DxRequiredRule,
    DxDataGrid,
    DxScrolling,
    DxColumn,
    DxSorting,
    DxSearchPanel,
    DxHeaderFilter,
    DxExport,
    DxChart,
    DxTitle,
    DxCommonSeriesSettings,
    DxSeries,
    DxLegend,
    DxCommonAxisSettings,
    DxGrid,
    DxTooltip,
  },
  mounted() {
    dsu.getAxiosSpaceAuth().then((res) => {
      this.spaceList = res.data.data;
      this.formData.spaceId = this.spaceList[0].spaceId;
    });
  },
  computed: {
    grid: function () {
      return this.$refs[this.gridRefName].instance;
    },
  },
  data() {
    return {
      searchFormRefName: "searchForm",
      formData: {},
      searchConditionData: {},
      defaultStartDate: defaultStartDate,
      defaultEndDate: defaultEndDate,
      dataSource: [],
      dataSourceGraph: [],
      typeName: "",
      gridRefName: "grid",
      spaceList: [],
    };
  },
  methods: {
    searchData() {
      const searchForm = this.$refs[this.searchFormRefName].instance;
      let url = "";
      let validationResult = searchForm.validate();
      if (validationResult.status != "valid") {
        return;
      }

      Object.assign(this.searchConditionData, this.formData);
      this.searchConditionData.startDate =
        dsu.getFormatDate(this.searchConditionData.startDate) + "000000";
      this.searchConditionData.endDate =
        dsu.getFormatDate(this.searchConditionData.endDate) + "235959";
      this.typeName = this.searchConditionData.type;

      if (this.typeName == "시간") {
        url = "selectPlayerJoinDataByHour";
      } else if (this.typeName == "일") {
        url = "selectPlayerJoinDataByDay";
      } else if (this.typeName == "주") {
        url = "selectPlayerJoinDataByWeek";
      } else if (this.typeName == "월") {
        url = "selectPlayerJoinDataByMonth";
      }

      this.grid.beginCustomLoading();

      dsu
        .getAxiosOBJGet("/api/UVTM/" + url, this.searchConditionData)
        .then((res) => {
          let response = res.data;
          if (response.result == "SUCCESS") {
            var data = [];
            Object.assign(data, response.data);
            this.dataSourceGraph = data;
            this.dataSource = response.data;

            let sumTotalCnt = 0;
            let sumPcCnt = 0;
            let sumMobileCnt = 0;

            for (let i = 0; i < this.dataSource.length; i++) {
              sumTotalCnt += this.dataSource[i].totalCnt;
              sumPcCnt += this.dataSource[i].pcCnt;
              sumMobileCnt += this.dataSource[i].mobileCnt;
            }

            this.dataSource.push({
              type: "총계",
              totalCnt: sumTotalCnt,
              pcCnt: sumPcCnt,
              mobileCnt: sumMobileCnt,
            });
          } else {
            fn.notifyError(response.msg);
          }
          this.grid.endCustomLoading();
        });
    },
    onCellPrepared(e) {
      if (e.rowType == "data") {
        if (e.column.dataField) {
          if (this.dataSource[this.dataSource.length - 1] === e.data) {
            e.cellElement.bgColor = "#f7f5f5";
          }
        }
      }
    },
    onExporting(e) {
      e.fileName = this.$route.meta.transName;
    },
  },
};
</script>

<style scoped>
#grid {
  max-height: 600px;
}
</style>
